import { call } from 'redux-saga/effects';
import { ConfigurationResource } from '../../core/resources/configuration.resource';
import { configurationSerializer } from '../../models/configuration/configuration.serializer';

export function* configurationSaga() {
  const data = yield call(ConfigurationResource.getConfiguration);

  return configurationSerializer(data);
}
